<main class="contact-page">
  <section class="contact-hero">
    <div class="contact-hero-inner">
      <div class="hero-eyebrow">
        <img [src]="branding.logoUrl()" alt="" class="hero-logo" />
        <span class="eyebrow-line"></span><span>We're listening</span>
      </div>
      <h1>Contact Us</h1>
      <p class="hero-description">Have a question, a compliment, or something we could do better? We'd love to hear about your experience.</p>
    </div>
  </section>

  <section class="contact-content">
    @if (contactSettings; as settings) {
      @if (settings.contactEmail || settings.contactPhone || settings.contactAddress) {
        <aside class="direct-contact" aria-label="Contact information">
          <div><span class="form-eyebrow">Get in touch</span><h2>Contact us directly</h2></div>
          @if (settings.contactEmail) {
            <div class="contact-detail"><span>Email us</span><a [href]="emailLink">{{ settings.contactEmail }}</a></div>
          }
          @if (settings.contactPhone) {
            <div class="contact-detail"><span>Call us</span><a [href]="phoneLink">{{ settings.contactPhone }}</a></div>
          }
          @if (settings.contactAddress) {
            <div class="contact-detail"><span>Our address</span><p class="contact-address">{{ settings.contactAddress }}</p></div>
          }
        </aside>
      }
    }
    @if (settingsError) {
      <p class="load-message" role="status">Direct contact details are temporarily unavailable. You can still send us a message below.</p>
    }

    <form class="contact-form" #contactForm="ngForm" (ngSubmit)="submitContactRequest(contactForm)" [attr.aria-busy]="isSubmitting">
      <header class="form-header">
        <div><span class="form-eyebrow">Share your experience</span><h2>Send us a message</h2>
          <p>Tell us which restaurant you visited and how we can help. For feedback about a visit, include the date, time, and relevant order details.</p>
        </div>
        <p class="required-note"><span class="required">*</span> Required fields</p>
      </header>
      <div class="form-body">
        <fieldset [disabled]="isSubmitting">
          <div class="form-grid">
            <div class="form-field span-12">
              <label for="contactName">Name <span class="required">*</span></label>
              <input id="contactName" name="name" [(ngModel)]="request.name" #name="ngModel" required maxlength="150" autocomplete="name" placeholder="First and last name" />
              @if (name.touched && (!request.name.trim())) { <small class="field-error">Enter your name.</small> }
            </div>
            <div class="form-field span-6">
              <label for="contactEmail">Email <span class="required">*</span></label>
              <input id="contactEmail" name="email" type="email" [(ngModel)]="request.email" #email="ngModel" required email maxlength="254" autocomplete="email" placeholder="name@example.com" />
              @if (email.touched && email.invalid) { <small class="field-error">Enter a valid email address.</small> }
            </div>
            <div class="form-field span-6">
              <label for="contactPhone">Phone <span class="optional">(optional)</span></label>
              <input id="contactPhone" name="phone" type="tel" [(ngModel)]="request.phone" maxlength="40" autocomplete="tel" placeholder="(555) 555-5555" />
            </div>
            <div class="form-field span-12">
              <label for="contactLocation">Restaurant Location <span class="required">*</span></label>
              <select id="contactLocation" name="locationId" [(ngModel)]="request.locationId" #location="ngModel" required [disabled]="locationsLoading || !locations.length">
                <option [ngValue]="null">{{ locationsLoading ? 'Loading restaurants…' : 'Select a restaurant' }}</option>
                @for (restaurant of locations; track restaurant.id) {
                  <option [ngValue]="restaurant.id">{{ restaurant.name }} — {{ restaurant.address }}</option>
                }
              </select>
              @if (location.touched && location.invalid) { <small class="field-error">Select a restaurant.</small> }
              @if (locationsError) {
                <p class="load-message" role="status">Unable to load restaurants. <button type="button" class="retry-button" (click)="loadLocations()">Try again</button></p>
              } @else if (!locationsLoading && !locations.length) {
                <p class="load-message" role="status">No restaurants are currently available. Please contact us directly.</p>
              }
            </div>
            <div class="form-field span-12">
              <label for="contactMessage">Message <span class="required">*</span></label>
              <textarea id="contactMessage" name="message" rows="7" [(ngModel)]="request.message" #message="ngModel" required maxlength="5000" placeholder="Tell us about your experience or how we can help…"></textarea>
              @if (message.touched && !request.message.trim()) { <small class="field-error">Enter a message.</small> }
            </div>
            <div class="span-12">
              <label class="contact-preference" for="wishToBeContacted">
                <input id="wishToBeContacted" name="wishToBeContacted" type="checkbox" [(ngModel)]="request.wishToBeContacted" />
                <span>I wish to be contacted about this</span>
              </label>
            </div>
          </div>
        </fieldset>
      </div>
      @if (statusMessage) {
        <div class="form-status" role="status" aria-live="polite">
          <div class="submission-message" [class.success-message]="submissionSucceeded" [class.error-message]="!submissionSucceeded"><p>{{ statusMessage }}</p></div>
        </div>
      }
      <footer class="form-footer">
        <p>Let us know if you'd like a response to your feedback.</p>
        <button class="submit-button" type="submit" [disabled]="isSubmitting || contactForm.invalid || locationsLoading || !locations.length || !request.name.trim() || !request.message.trim()">
          @if (isSubmitting) { <span class="spinner" aria-hidden="true"></span> Sending… }
          @else { <span>Send Message</span><span class="button-arrow" aria-hidden="true">→</span> }
        </button>
      </footer>
    </form>
  </section>
</main>

